module.exports = __webpack_public_path__ + "static/media/img50.9830152c.jpg";